import React from 'react';
import { describeAction, resolveActions } from '../../policy/policyModel';

// The winget id in the Detect box: the string, null when the box parses and names none, undefined while it is empty or does not parse.
const wingetIdOf = (detectText) => {
  if (!detectText || !detectText.trim()) return undefined;
  try {
    const detect = JSON.parse(detectText);
    if (!detect || typeof detect !== 'object' || Array.isArray(detect)) return undefined;
    return detect.wingetId || null;
  } catch (ex) {
    return undefined;
  }
};

// Under a definition's Actions box: what each action will actually run for this program, which is the action defaults with the changes in the
// box on top, {wingetId} filled in from the Detect box (a program with no winget id is shown no winget install or update). Nothing to show while
// the JSON does not parse or the defaults have not been read.
//   defaults    the actiondefaults policies that apply (null while being read)
//   text        the JSON in the Actions box
//   detectText  the JSON in the Detect box
export default function ActionPreview({ defaults, text, detectText }) {
  if (defaults === null) return null;
  let changes = {};
  if (text && text.trim()) {
    try { changes = JSON.parse(text); } catch (ex) { return null; }
    if (!changes || typeof changes !== 'object' || Array.isArray(changes)) return null;
  }
  const resolved = resolveActions(defaults, changes, wingetIdOf(detectText));
  const lines = Object.keys(resolved).map((name) => describeAction(name, resolved[name]));
  return (
    <div className="action-preview">
      <div className="showcmd-label">What will run</div>
      {lines.length > 0
        ? <pre className="code-block" aria-label="What will run">{lines.join('\n')}</pre>
        : <div className="help">No action defaults are set yet, so there is nothing to run until they are (or this program names a script).</div>}
    </div>
  );
}
